const API_ENDPOINTS = {
  collections: process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL}/collections`
      : 'http://localhost:8000/collections',
  collectionsIngest: process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL}/collections/ingest`
      : 'http://localhost:8000/collections/ingest',
  collectionsUpload: process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL}/collections/upload`
      : 'http://localhost:8000/collections/upload',
  conversations: process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL}/conversations`
      : 'http://localhost:8000/conversations',
  templates: process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL}/templates`
      : 'http://localhost:8000/templates',
  templatesUpload: process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL}/templates/upload`
      : 'http://localhost:8000/templates/upload',
  templatesDetails: process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL}/templates/details`
      : 'http://localhost:8000/templates/details',
  interactions: process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL}/interactions`
      : 'http://localhost:8000/interactions',
  login: process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL}/login`
      : 'http://localhost:8000/login',
  reports: process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL}/reports`
      : 'http://localhost:8000/reports',
  demo: process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL}/demo`
      : 'http://localhost:8000/demo',
  // websockets: process.env.REACT_APP_WS_URL || null,
  email: process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}`
  : 'http://localhost:8000/',
};
  
  export default API_ENDPOINTS;
  